import React from "react";

export const InstantSearchNoResults: React.FC = (props) => {
  return (
    <div className="text-center py-16">
      <p>
        <strong className="no-results">No results found.</strong>
      </p>
    </div>
  );
};
